<template>
  <div class="automation-trigger-settings">
    <p>
      {{ t('automations-form-triggers_config-quotation_without_order-description') }}
    </p>

    <div class="field">
      <label class="label">{{ t('automations-form-triggers_config-quotation_without_order-time_label') }}</label>
      <input
        type="number"
        min="1"
        class="form-control"
        v-model.number="days.exact"
        :placeholder="t('automations-form-triggers_config-quotation_without_order-time_placeholder')"
      />
    </div>

    <div class="field">
      <label class="label">{{ t('automations-form-triggers_config-quotation_without_order-unit_label') }}</label>
      <select v-model="unit" class="form-control">
        <option value="days">{{ t('automations-form-triggers_config-quotation_without_order-units-days') }}</option>
        <option value="hours">{{ t('automations-form-triggers_config-quotation_without_order-units-hours') }}</option>
        <option value="minutes">{{ t('automations-form-triggers_config-quotation_without_order-units-minutes') }}</option>
      </select>
    </div>

    <div class="field">
      <label class="label">{{ t('automations-form-triggers_config-quotation_without_order-status_label') }}</label>
      <select v-model="filterStatus" class="form-control" multiple>
        <option value="all">{{ t('automations-form-triggers_config-quotation_without_order-all_status') }}</option>
        <option
          v-for="status in statusList"
          :value="status.id"
          :key="status.id"
        >
          {{ status.external_label }}
        </option>
      </select>
    </div>
  </div>
</template>

<script>
import keviApi from "../../../keviApi";

export default {
  props: {
    value: { type: Array, default: () => [] },
  },
  data() {
    const value = this.value?.[0] || {};
    let filterStatus = value.status || [];
    if (!Array.isArray(filterStatus)) filterStatus = [filterStatus];

    return {
      filterStatus,
      days: { exact: value.days?.exact ?? null },
      unit: value.unit || "days",
      statusList: [],
    };
  },
  computed: {
    errors() {
      const errors = {};
      if (!this.days.exact || this.days.exact <= 0) errors.exact = "required";
      return errors;
    },
  },
  methods: {
    t(term, replaces) {
      return this.$root.t(term, replaces);
    },
    isValid() {
      return Object.keys(this.errors).length === 0;
    },
    loadStatusList() {
      const options = keviApi.getOptions(
        "settings/external-quotations-status",
        "GET"
      );
      this.$http(options).then((response) => {
        if (response.status === 200)
          this.statusList = response.body.status || [];
      });
    },
    emitChange() {
      const payload = [
        {
          status: this.filterStatus,
          days: { exact: this.days.exact },
          unit: this.unit,
        },
      ];
      if (JSON.stringify(payload) !== JSON.stringify(this.value))
        this.$emit("input", payload);
    },
  },
  mounted() {
    this.loadStatusList();
    this.emitChange();
  },
  watch: {
    unit: "emitChange",
    filterStatus: "emitChange",
    days: { deep: true, handler: "emitChange" },
    value: {
      deep: true,
      handler(newVal) {
        const val = newVal?.[0] || {};
        this.filterStatus = Array.isArray(val.status)
          ? val.status
          : [val.status || []];
        this.days = { exact: val.days?.exact ?? null };
        this.unit = val.unit || "days";
      },
    },
  },
};
</script>
